import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { UserCombi } from "../../../../model";
import { UserCombiFromToModule } from "../usercombi-from-to/usercombi-from-to-modal.module";
import { TranslateDirective } from "@ngx-translate/core";

@Component({
  selector: 'app-icon-dropdown-item-usercombi-queue',
  templateUrl: './icon-dropdown-item-usercombi-queue.component.html',
  styleUrls: ['./icon-dropdown-item-usercombi-queue.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UserCombiFromToModule, TranslateDirective],
  standalone: true
})
export class IconDropdownItemUsercombiQueueComponent {
  readonly userCombi = input.required<UserCombi>();
}
